"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HTTPError = exports.FacetsCustomFieldType = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
class HTTPError extends Error {
  constructor(message, status) {
    super(message);
    (0, _defineProperty2.default)(this, "status", void 0);
    this.status = status;
  }
}
exports.HTTPError = HTTPError;
let FacetsCustomFieldType = exports.FacetsCustomFieldType = /*#__PURE__*/function (FacetsCustomFieldType) {
  FacetsCustomFieldType["Date"] = "date";
  FacetsCustomFieldType["Enum"] = "enum";
  FacetsCustomFieldType["Number"] = "number";
  FacetsCustomFieldType["ListOfNumbers"] = "number-list";
  FacetsCustomFieldType["Text"] = "text";
  FacetsCustomFieldType["ListOfTexts"] = "text-list";
  return FacetsCustomFieldType;
}({});
//# sourceMappingURL=types.js.map